import React, { Component } from 'react'
import PropTypes from 'prop-types'
import LegendAccounting from './LegendAccounting.jsx'
import CalendarAccounting from './CalendarAccounting.jsx'
//import _ from 'lodash'

class AccountingComponent extends Component{
  componentDidMount() {
    this.props.fetchData()
  }

  render() {
    if (this.props.accounting.colors) {
      return <div className="row"><div className="col-sm-8"><CalendarAccounting accounting={this.props.accounting} setMonth={this.props.setMonth} setStatistics={this.props.setStatistics} setPublicHolidays={this.props.setPublicHolidays}></CalendarAccounting></div><div className="col-sm-3 offset-sm-1"><LegendAccounting accounting={this.props.accounting}></LegendAccounting></div></div>
    }
    return <div></div>
  }
}

AccountingComponent.propTypes = {
  fetchData: PropTypes.func.isRequired,
  accounting: PropTypes.object.isRequired,
  setMonth: PropTypes.func.isRequired,
  setStatistics: PropTypes.func.isRequired,
  setPublicHolidays: PropTypes.func.isRequired,
}

export default AccountingComponent
